export class InvoicePaymentPage {

    static Instance: InvoicePaymentPage;
    form: HTMLFormElement;

    get invoiceNumberInput() { return <HTMLInputElement>this.form.querySelector('input[name="invoice-number"]'); }
    get invoiceNumber() { return this.invoiceNumberInput.value; }
    set invoiceNumber(to: string) { this.invoiceNumberInput.value = to; }

    get emailAddressInput() { return <HTMLInputElement>this.form.querySelector('input[name="invoice-email"]'); }
    get emailAddress() { return this.emailAddressInput.value; }
    set emailAddress(to: string) { this.emailAddressInput.value = to; }

    get invoiceAmountInput() { return <HTMLInputElement>this.form.querySelector('input[name="invoice-amount"]'); }
    get invoiceAmount() {
        let nominal = parseFloat(this.invoiceAmountInput.value || '0');
        if (isNaN(nominal)) nominal = 0;
        return Math.round(nominal * 100) / 100;
    }
    set invoiceAmount(to: number) {
        if (isNaN(to) || to < 0) to = 0;

        to = Math.round(to * 100) / 100;

        let asStr = `${to}`;
        /* if (asStr.indexOf('.') !== -1) {
            let ltok = asStr.split('.')[0] || '';
            let rtok = asStr.split('.')[1] || '';
            if (rtok.length < 2) {
                asStr = `${ltok}.${rtok}0`;
            }
        } else {
            asStr += '.00';
        } */
        this.invoiceAmountInput.value = asStr;

        this.updateSurchargeLabels();
    }

    updateSurchargeLabels() {
        document.querySelectorAll('[data-surcharge-factor]').forEach((el: HTMLElement) => {
            el.innerText = (this.invoiceAmount * (parseFloat(el.dataset.surchargeFactor) * 0.01)).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
        });
    }

    get creditCardSurchargeRows() { return this.form.querySelectorAll('.credit-card-surcharge-row'); }

    get creditCardSurchargeSelect() { return <HTMLSelectElement>this.form.querySelector('select[name="credit-surcharge"]'); }
    get creditCardSurchageIncluded() {
        return this.creditCardSurchargeSelect.value == 'true' && this.invoiceAmount >= 1000;
    }

    get creditCardSurchargeAgreedCheckbox() { return <HTMLInputElement>this.form.querySelector('[name="credit-surcharge-agreed"]'); }
    get creditCardSurchargeAgreed() { return this.creditCardSurchageIncluded && this.creditCardSurchargeAgreedCheckbox.checked; }

    get inputs() {
        return [
            this.invoiceNumberInput,
            this.emailAddressInput,
            this.invoiceAmountInput,
            this.creditCardSurchargeSelect,
            this.creditCardSurchargeAgreedCheckbox,
        ];
    }

    constructor(form: HTMLFormElement) {
        this.form = form;
        //console.log(`Invoice payment page`, this);
        InvoicePaymentPage.Instance = this;

        this.inputs.forEach(el => {
            if (!el) return;

            ['input', 'focus', 'blur', 'keypress', 'keydown', 'change', 'paste'].forEach(cb => {
                el.addEventListener(cb, ev => this.validate(el, ev))
            });
        });


        globalThis['PAYWAY'] = globalThis['payway'].createCreditCardFrame({
            publishableApiKey: this.form.dataset.paymentProcessor,
            tokenMode: 'callback',
            onValid() {
                //InvoicePaymentPage.Instance.submitButton.disabled = false;
            },
            onInvalid() {
                //InvoicePaymentPage.Instance.submitButton.disabled = true;
            }
        }, this.paywayInitialised);

        this.validate(null, null);
    }

    get submitButton() { return <HTMLButtonElement>document.getElementById('payway-cc-submit'); }

    paywayInitialised(err, frame) {
        //console.log('payway initialised', err, frame);
        //console.dir(frame);
        //console.log('this', this);
        InvoicePaymentPage.Instance.validate(null, null);

        InvoicePaymentPage.Instance.submitButton.addEventListener('click', ev => {
            document.querySelectorAll('.field-feedback').forEach((el: HTMLElement) => {
                el.innerText = '';
                el.parentElement.querySelectorAll('input').forEach((i: HTMLInputElement) => {
                    i.classList.remove('is-invalid');
                });
            });

            InvoicePaymentPage.Instance.form.style.pointerEvents = 'none';
            InvoicePaymentPage.Instance.form.style.opacity = '0.5';

            InvoicePaymentPage.Instance.submitButton.disabled = true;
            let errMesg = (<HTMLElement>document.querySelector('.invalid-cc-message'));
            errMesg.classList.add('d-none');

            frame.getToken((err, data) => {
                if (err) {
                    InvoicePaymentPage.Instance.submitButton.disabled = false;
                    errMesg.classList.remove('d-none');
                    InvoicePaymentPage.Instance.form.style.pointerEvents = 'all';
                    InvoicePaymentPage.Instance.form.style.opacity = '1';

                    return;
                }
                //console.log(`single use token id: ${data.singleUseTokenId}`, data);
                //let amount = InvoicePaymentPage.Instance.invoiceAmount;
                let formData = new FormData(InvoicePaymentPage.Instance.form);
                formData.append('singleUseTokenId', data.singleUseTokenId);
                formData.append('cardType', data.creditCard.cardScheme);
                fetch(InvoicePaymentPage.Instance.form.action, {
                    body: formData,
                    method: 'post',
                }).then(resp => {
                    if (resp.ok) {
                        resp.json().then(json => {
                            //console.log(`response passed from payway`, json);
                            if (json.invalidField) {
                                try {
                                    let el = <HTMLInputElement | HTMLSelectElement>document.querySelector(json.invalidField);
                                    el.scrollIntoView({
                                        block: 'center',
                                        behavior: 'smooth',
                                    });
                                    el.classList.add('is-invalid');
                                    let feedback = <HTMLElement>el.parentElement.querySelector('.field-feedback');
                                    if (feedback) {
                                        feedback.innerText = json.invalidFeedback;
                                    }
                                } catch (err) {
                                    console.log(err);
                                }
                                InvoicePaymentPage.Instance.form.style.pointerEvents = 'all';
                                InvoicePaymentPage.Instance.form.style.opacity = '1';
                            }
                            else if (json.failMessage) {
                                //InvoicePaymentPage.Instance.form.remove();
                                document.querySelector('.payment-is-unsuccessful').classList.remove('d-none');
                                (<HTMLElement>document.querySelector('.payment-is-unsuccessful .error-info')).innerText = json.invalidField;
                                (<HTMLElement>document.querySelector('.payment-is-unsuccessful')).scrollIntoView({
                                    block: 'start',
                                });
                                InvoicePaymentPage.Instance.form.style.pointerEvents = 'all';
                                InvoicePaymentPage.Instance.form.style.opacity = '1';
                            }
                            else if (json.failed) {
                                InvoicePaymentPage.Instance.form.remove();
                                document.querySelector('.payment-is-unsuccessful').classList.remove('d-none');
                                (<HTMLElement>document.querySelector('.payment-is-unsuccessful .error-info')).innerText = json.failed;

                                (<HTMLElement>document.querySelector('.payment-is-unsuccessful')).scrollIntoView({
                                    block: 'start',
                                });
                            } else {
                                //console.log(json);
                                InvoicePaymentPage.Instance.form.remove();
                                document.querySelector('.payment-is-successful').classList.remove('d-none');

                                (<HTMLElement>document.querySelector('.payment-is-successful .payment-amount')).innerText = json.paymentAmount;
                                (<HTMLElement>document.querySelector('.payment-is-successful .payment-order')).innerText = json.orderNumber;
                                (<HTMLElement>document.querySelector('.payment-is-successful .payment-date')).innerText = json.transactionDateTime;
                                (<HTMLElement>document.querySelector('.payment-is-successful .payment-receipt')).innerText = json.receiptNumber;

                                (<HTMLElement>document.querySelector('.payment-is-successful')).scrollIntoView({
                                    block: 'start',
                                });
                            }

                            /*if (json.isSuccessStatusCode === true) {
                                InvoicePaymentPage.Instance.form.remove();
                                document.querySelector('.payment-is-successful').classList.remove('d-none');
                            } else {
                                InvoicePaymentPage.Instance.form.remove();
                                document.querySelector('.payment-is-unsuccessful').classList.remove('d-none');
                            }*/
                        });
                    } else {
                        InvoicePaymentPage.Instance.form.style.pointerEvents = 'all';
                        InvoicePaymentPage.Instance.form.style.opacity = '1';
                    }
                }).catch(err => {
                    InvoicePaymentPage.Instance.form.style.pointerEvents = 'all';
                    InvoicePaymentPage.Instance.form.style.opacity = '1';
                });
            });
        });

        /* frame.getToken((err, data) => {
            if (err) {
                console.error(`Error getting token ${err.message}`);
                return;
            }
            console.log(`single use token id: ${data.singleUseTokenId}`);
        }); */
    }

    validate(el: HTMLInputElement | HTMLSelectElement, ev: Event) {
        let invoiceNumber = '';
        //console.log(`validate()`, el, ev);

        for (let i = 0; i < this.invoiceNumber.length && i < 7; i++) {
            if (this.invoiceNumber.charCodeAt(i) >= 0x30 && this.invoiceNumber.charCodeAt(i) <= 0x39) {
                invoiceNumber += this.invoiceNumber[i];
            }
        }
        if (this.invoiceNumber != invoiceNumber) {
            this.invoiceNumber = invoiceNumber;
            this.invoiceNumberInput.focus();
        }

        if (invoiceNumber.length == 7) {
            this.invoiceNumberInput.classList.add('is-valid');
            this.invoiceNumberInput.classList.remove('is-invalid');
        } else {
            this.invoiceNumberInput.classList.remove('is-valid');
            if (el === this.invoiceNumberInput || (el !== null && el.matches(':focus'))) {
                this.invoiceNumberInput.classList.add('is-invalid');
                //el.focus();
            }
        }

        let emailValidation = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        if (this.emailAddress.length) {
            if (!this.emailAddress.match(emailValidation)) {
                this.emailAddressInput.classList.add('is-invalid');
                this.emailAddressInput.classList.remove('is-valid');
            } else {
                this.emailAddressInput.classList.add('is-valid');
                this.emailAddressInput.classList.remove('is-invalid');
            }
        } else {
        }

        let invoiceAmount = '';
        for (let i = 0; i < this.invoiceAmountInput.value.length; i++) {
            let c = this.invoiceAmountInput.value.charCodeAt(i);
            if ((c >= 0x30 && c <= 0x39) || c == 0x2E || c == 0x2D) {
                invoiceAmount += this.invoiceAmountInput.value[i];
            }
        }
        while (invoiceAmount.length > 0 && invoiceAmount[0] == '0') {
            if (invoiceAmount.length > 1 && invoiceAmount[1] == '.') {
                break;
            }
            invoiceAmount = invoiceAmount.substring(1);
        }

        let appendDecimal = invoiceAmount.endsWith('.');
        //let appendDecimalZero = invoiceAmount.endsWith('.0');
        if (appendDecimal) invoiceAmount = invoiceAmount.replace('.', '');
        if ((parseFloat(invoiceAmount) != this.invoiceAmount) || this.invoiceAmountInput.value != invoiceAmount) {
            this.invoiceAmount = parseFloat(invoiceAmount);
            //this.invoiceAmountInput.value = (invoiceAmount);
        }
        //this.invoiceAmount = this.invoiceAmount;
        if (appendDecimal) this.invoiceAmountInput.value += '.';
        //else if (appendDecimalZero) this.invoiceAmountInput.value += '.0';

        this.updateSurchargeLabels();

        if (this.invoiceAmount >= 1000) {
            this.creditCardSurchargeRows.forEach(c => c.classList.remove('d-none'));
        } else {
            this.creditCardSurchargeRows.forEach(c => c.classList.add('d-none'));
        }

        if (this.creditCardSurchageIncluded) {
            this.form.querySelectorAll('.credit-surcharge-included').forEach(e => e.classList.remove('d-none'));
            this.form.querySelectorAll('.credit-surcharge-not-included').forEach(e => e.classList.add('d-none'));
        } else {
            this.form.querySelectorAll('.credit-surcharge-included').forEach(e => e.classList.add('d-none'));
            this.form.querySelectorAll('.credit-surcharge-not-included').forEach(e => e.classList.remove('d-none'));
        }

        let preventSubmit = true;
        if (this.invoiceNumberInput.classList.contains('is-valid')) {
            if (this.emailAddressInput.classList.contains('is-valid')) {
                if (this.invoiceAmount > 0) {
                    if (this.invoiceAmount >= 1000) {
                        if (this.creditCardSurchageIncluded) {
                            if (this.creditCardSurchargeAgreed) {
                                preventSubmit = false;
                            }
                        } else {
                            preventSubmit = false;
                        }
                    } else {
                        preventSubmit = false;
                    }
                }
            }
        }

        if (this.invoiceNumber.length != 7) preventSubmit = true;

        (<HTMLAnchorElement>document.querySelector('a.redo-form-button')).href = location.pathname + `?invoice=${this.invoiceNumber}&email=${encodeURIComponent(this.emailAddress)}&amount=${encodeURIComponent(this.invoiceAmount)}&sci=${this.creditCardSurchageIncluded}`;

        let paymentButtonLabel = (<HTMLElement>this.submitButton.querySelector('.label'));
        if (paymentButtonLabel) {
            if (preventSubmit) {
                paymentButtonLabel.innerText = `Submit`;
                (<HTMLElement>document.querySelector('.cc-payment-disclaimer')).innerText = '';
            } else {
                paymentButtonLabel.innerText = `DEBIT ${this.invoiceAmount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' })} (AUD)${this.invoiceAmount >= 1000 ? ' *' : ''}`;
                if (this.invoiceAmount >= 1000) {
                    (<HTMLElement>document.querySelector('.cc-payment-disclaimer')).innerText = '* excluding relevant credit surcharge';
                }
            }
        }

        this.submitButton.disabled = preventSubmit;
    }
}

if (document.readyState === 'complete') {
    if (!globalThis['PAYMENTPROCESSOR']) {
        document.querySelectorAll(`form[data-payment-processor]`).forEach(el => {
            globalThis['PAYMENTPROCESSOR'] = new InvoicePaymentPage(<HTMLFormElement>el);
        });
    }
}
else {
    document.addEventListener('readystatechange', ev => {
        if (document.readyState == 'interactive') {
        }

        if (document.readyState === 'complete') {
            if (globalThis['PAYMENTPROCESSOR']) return;
            document.querySelectorAll(`form[data-payment-processor]`).forEach(el => {
                globalThis['PAYMENTPROCESSOR'] = new InvoicePaymentPage(<HTMLFormElement>el);
            });
        }
    });
}